<template>
  <div id="root">
    <div class="sc-jRuhRL bFtZkw">
      <div class="sc-jUpvKA kYhPbP">
        <div class="loginContent">
          <img class="img" src="./images/title-login.png" alt="" />
          <div class="tit">监 测 管 理 系 统</div>
          <form class="ant-form ant-form-horizontal loginForm">
            <div class="ant-row ant-form-item formItem">
              <div class="ant-col ant-form-item-control-wrapper">
                <div class="ant-form-item-control"><span class="ant-form-item-children">欢迎登录</span></div>
              </div>
            </div>
            <div class="ant-row ant-form-item formItem name">
              <div class="ant-col ant-form-item-control-wrapper">
                <div class="ant-form-item-control">
                  <span class="ant-form-item-children">
                    <div id="newlogin_username" data-__meta="[object Object]" data-__field="[object Object]" class="sc-jdfcpN kHIpnj">
                      <span class="ant-input-affix-wrapper ant-input-affix-wrapper-lg"
                        ><span class="ant-input-prefix"
                          ><i aria-label="图标: user" class="anticon anticon-user" style="color: rgba(0, 0, 0, 0.25)"
                            ><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="user" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                              <path
                                d="M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                              ></path></svg></i
                        ></span>
                        <a-input placeholder="登录名" type="text" class="ant-input ant-input-lg" v-model="form.username" />
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="ant-row ant-form-item formItem">
              <div class="ant-col ant-form-item-control-wrapper">
                <div class="ant-form-item-control">
                  <span class="ant-form-item-children"
                    ><div id="newlogin_password" data-__meta="[object Object]" data-__field="[object Object]" class="sc-jdfcpN kHIpnj">
                      <span class="ant-input-password ant-input-password-large ant-input-affix-wrapper ant-input-affix-wrapper-lg"
                        ><span class="ant-input-prefix"
                          ><i aria-label="图标: lock" class="anticon anticon-lock" style="color: rgba(0, 0, 0, 0.25)"
                            ><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="lock" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                              <path
                                d="M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                              ></path></svg></i
                        ></span>
                        <a-input-password size="large" placeholder="密码" action="click" type="password" class="ant-input ant-input-lg" v-model="form.password" />
                      </span></div
                  ></span>
                </div>
              </div>
            </div>
            <div class="ant-row ant-form-item formItem">
              <div class="ant-col ant-form-item-control-wrapper">
                <div class="ant-form-item-control">
                  <span class="ant-form-item-children">
                    <button type="button" class="ant-btn formItemBtn ant-btn-primary ant-btn-lg" @click="handleLogin"><span>登 录</span></button>
                    <div class="register">注册新用户</div></span
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      loading: false, // 是否加载中
      form: {
        username: '',
        password: '',
      },
    };
  },
  methods: {
    // 登录接口
    handleLogin() {
      this.loading = true;
      this.$store
        .dispatch('LoginByUsername', this.form)
        .then((res) => {
          this.$notification.success({
            message: '成功',
            description: '登录成功',
          });
          this.$router.push('/');
        })
        .catch((e) => {
          this.$notification.error({
            message: '失败',
            description: e.hasOwnProperty('data') ? e.data.msg : '登录失败',
          });
          console.warn(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-input {
  border: 0 !important;
  padding: {
    left: 0;
  };
  &:focus {
    box-shadow: unset;
  }
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

::selection {
  color: #fff;
  background: #6c9ae0;
}

body,
html {
  width: 100%;
  height: 100%;
}

div {
  display: block;
}

html {
  --antd-wave-shadow-color: #6c9ae0;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Chinese Quote', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;
  -webkit-font-smoothing: antialiased;

  font-variant: tabular-nums;
  line-height: 1.5;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;

  display: block;
}

#root {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.bFtZkw {
  width: 100%;
  height: 100%;
}

.kYhPbP {
  width: 100%;
  height: 100%;
  background-image: url(./images/bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.kYhPbP .loginContent {
  width: 800px;
  height: 480px;
  background-color: rgb(0, 90, 245);
  background-image: url('./images/content.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 24px;
  position: relative;
}

.kYhPbP .loginContent .img {
  position: absolute;
  width: 320px;
  height: 102px;
  top: 166px;
  left: 32px;
}

img {
  vertical-align: middle;
  border-style: none;
}

.kYhPbP .loginContent .tit {
  position: absolute;
  top: 290px;
  left: 26px;
  width: 312px;
  height: 24px;
  margin: 22px 0px 0px 8px;
  color: rgb(255, 255, 255);
  font-size: 24px;
  text-align: center;
  font-weight: bolder;
}

form {
  display: block;
  margin-top: 0em;
}

.ant-form {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  -webkit-font-feature-settings: 'tnum', 'tnum';
  font-feature-settings: 'tnum', 'tnum';
}

.kYhPbP .loginForm {
  padding: 50px 20px 20px;
  border-radius: 24px;
  height: 100%;
  position: absolute;
  right: 0px;
  background-color: rgb(255, 255, 255);
  width: 400px;
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
}

.ant-form-item {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  -webkit-font-feature-settings: 'tnum', 'tnum';
  font-feature-settings: 'tnum', 'tnum';
  margin: 0 0 24px;
  vertical-align: top;
}

.ant-row {
  position: relative;
  height: auto;
  margin-right: 0;
  margin-left: 0;
  zoom: 1;
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.ant-row + .ant-row:before,
.ant-row:after {
  clear: both;
}

.ant-row:after,
.ant-row:before {
  display: table;
  content: '';
}

.ant-row:after,
.ant-row:before {
  display: table;
  content: '';
}

.kYhPbP .loginForm .formItem {
  width: 360px;
  height: 60px;
  padding: 0px 20px;
  margin-bottom: 36px;
}

.kYhPbP .loginForm .formItem:first-child {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAQBAMAAAAsdmq7AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURRhs/xRr/xRq/xRq/xRq/xRq/xRq/xRq/xRq/xRq/xRq/xRq/xRq/xRq/z3jR8sAAAAOdFJOUwQNXhZVb2YeLk0nRT42wu3liAAAAaxJREFUOMttkzHOglAQhOUGGG5AXuwNBb2h4QByABK9gAUJJyAmdjaEAzzDDQzcQOwt4C7u7O5D/H9fP5NvZuet9vQOR3ohPWOSJEnTuq7vXdf1wzA8J3qXqqrObdvagl4cRdF2u6bnrfCgz8hhk+dhuNuRwZX0TUMGDzIYx2l6vUhPBta2ZHA6qYPvOwMmgP6boO/74fkkhAsIbkoQx5AHAPA8NcgydTBhQg7XK/SNRBgmIbghQlkuCdbfBJsNEeyMAtSNIxilgzNlkARMwAkkA/SfDCDgEkCADhABBFWLCNYKATt8SswyEHAF0NeEcOcOSI8I3AEIbLlMIHqJcABALg5pggR1pw4wcAQlWozIIZAO/JnAIcgZNQLrOYJ2wHqNwB14v88IAhlSLztggpteIZYh/elgSZCm2oGUOCkBOmwLHUIgehdhvz/KEk1ofkVgAp4iSiyIIFr/J5AIjOCmzA6j60CviBI1gf91hWOY65BoBw06ePBf0CVKB4UtYiYIsOWVv9yBlmjcZ5Ipz3/hzCW4MwrBHAFnyPkvmLkDnfJniThj6TpwWyb9G9eOr+hrlIUtAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-size: 64px 8px;
  background-position: 20px 25px;
  -webkit-box-pack: start;
  justify-content: flex-start;
  font-family: PingFangSC;
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 2px;
  color: var(--main-main-10);
}

.kYhPbP .loginForm .formItem {
  width: 360px;
  height: 60px;
  padding: 0px 20px;
  margin-bottom: 36px;
}

.ant-col {
  position: relative;
  min-height: 1px;
}

.ant-form-item-control {
  position: relative;
  line-height: 40px;
  zoom: 1;
}

.ant-form-item-control:after,
.ant-form-item-control:before {
  display: table;
  content: '';
}

.ant-form-item-control:after {
  clear: both;
}

.ant-form-item-children {
  position: relative;
}

.ant-input-affix-wrapper {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  -webkit-font-feature-settings: 'tnum', 'tnum';
  font-feature-settings: 'tnum', 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: start;
}

.kHIpnj .ant-input-affix-wrapper {
  height: 48px;
}

.ant-input-affix-wrapper .ant-input-prefix,
.ant-input-affix-wrapper .ant-input-suffix {
  position: absolute;
  top: 50%;
  z-index: 2;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
  line-height: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.ant-input-affix-wrapper .ant-input-prefix {
  left: 12px;
}

.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

svg:not(:root) {
  overflow: hidden;
}

.anticon > * {
  line-height: 1;
}

svg:not(:root) {
  overflow: hidden;
}

.anticon svg {
  display: inline-block;
}

.ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 1.5;
}

button,
input {
  overflow: visible;
}

.ant-input {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  -webkit-font-feature-settings: 'tnum', 'tnum';
  font-feature-settings: 'tnum', 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  outline: none;
}

.ant-input-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}

input[type='number'],
input[type='password'],
input[type='text'],
textarea {
  -webkit-appearance: none;
}

[role='button'],
a,
area,
button,
input:not([type='range']),
label,
select,
summary,
textarea {
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}

.ant-input:placeholder-shown {
  text-overflow: ellipsis;
}

.ant-input-affix-wrapper .ant-input {
  position: relative;
  text-align: inherit;
}

.ant-input-affix-wrapper .ant-input {
  min-height: 100%;
}

.ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 30px;
}

.ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 30px;
}

.kHIpnj .ant-input-affix-wrapper .ant-input {
  border-top: none;
  border-right: none;
  border-left: none;
  border-image: initial;
  border-radius: 0px;
  border-bottom: 1px solid rgba(10, 35, 61, 0.09);
}

.ant-input-affix-wrapper .ant-input-suffix {
  right: 12px;
}

.ant-input-affix-wrapper .ant-input-prefix,
.ant-input-affix-wrapper .ant-input-suffix {
  position: absolute;
  top: 50%;
  z-index: 2;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
  line-height: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.ant-input-password-icon {
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon svg {
  display: inline-block;
}

.ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 1.5;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[type='reset'],
[type='submit'],
button,
html [type='button'] {
  -webkit-appearance: button;
}

.ant-btn {
  line-height: 1.499;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  cursor: pointer;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  height: 32px;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border: 1px solid #d9d9d9;
}

.ant-btn,
.ant-btn:active,
.ant-btn:focus {
  outline: 0;
}

.ant-btn-lg {
  height: 40px;
  padding: 0 15px;
  font-size: 16px;
  border-radius: 4px;
}

.ant-btn-primary {
  color: #fff;
  background-color: #6c9ae0;
  border-color: #6c9ae0;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.05);
}

.kYhPbP .loginForm .formItem .formItemBtn {
  height: 48px;
  line-height: 48px;
  width: 100%;
  border-radius: 6px;
  margin-top: 16px;
}

.ant-btn > i,
.ant-btn > span {
  display: inline-block;
  -webkit-transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  pointer-events: none;
}
</style>
